import { ProfileListItemSmallContainer } from './ProfileListItem.styles';
import { memo, useMemo, useState } from 'react';
import { IProfileLink } from 'shared/interfaces/IProfile';
import { Grid } from '@material-ui/core';
import { IMyLinkTalentInfo } from 'pages/MyLinks/types';
import ProfileListMe from './ProfileListMe/ProfileListMe';
import ProfileListCheckbox from './ProfileListCheckbox/ProfileListCheckbox';
import ProfileListLink from './ProfileLink/ProfileListLink';

type ProfileListItemSmallProps = {
  profileLink: IProfileLink;
  selectedPrimary: string | null;
  setSelectedPrimary: any;
  talentInfo: IMyLinkTalentInfo;
};

const ProfileListItemSmall = ({
  profileLink,
  selectedPrimary,
  setSelectedPrimary,
  talentInfo,
}: ProfileListItemSmallProps) => {
  const published = useMemo(() => (profileLink ? profileLink?.is_published : false), [profileLink]);
  const [isPublished, setIsPublished] = useState<boolean>(published);

  return (
    <ProfileListItemSmallContainer>
      <Grid container alignItems="center" spacing={1}>
        <Grid item xs={12} md={6} lg={3}>
          <ProfileListMe
            profileLink={profileLink}
            isPublished={isPublished}
            setIsPublished={setIsPublished}
            selectedPrimary={selectedPrimary}
            country_code={talentInfo?.talent_country_code}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <ProfileListCheckbox
            isPublished={isPublished}
            profileLink={profileLink}
            selectedPrimary={selectedPrimary}
            setSelectedPrimary={setSelectedPrimary}
          />
        </Grid>
        <Grid item xs={12} md={12} lg={4}>
          <ProfileListLink profileLink={profileLink} talentInfo={talentInfo} />
        </Grid>
      </Grid>
    </ProfileListItemSmallContainer>
  );
};

export default memo(ProfileListItemSmall);
